/** @jsx jsx */
import { jsx } from '@emotion/core';
import LoadingPage from 'components/LoadingPage';
import useNavigationHelpers from 'hooks/useNavigationHelpers';
import { useEffect } from 'react';
import useIssuance from './useIssuance';

export const IssuanceLoadingPage: React.FC = () => {
  const issuancePolling = useIssuance();
  const { push } = useNavigationHelpers();

  useEffect(() => {
    const issuance = async () => {
      try {
        const issuanceResult = await issuancePolling();
        if (issuanceResult === 'success') {
          push('/checkout-approval');
        } else if (issuanceResult === 'timeout') {
          push('/unified/issuance-timeout');
        } else {
          push('/unified/issuance-error');
        }
      } catch (e) {
        push('/unified/issuance-error');
      }
    };

    issuance();
    // Ensure we only sent this once.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <LoadingPage headerTitle={'unified.issuanceLoadingHeader'} />;
};
